import { Download, FileText } from 'lucide-react';
import { buttonClasses } from './Button';
import { cn } from '@/lib/utils';

/** Product catalogue PDF in public/ (served by nginx with its own location block). */
export const CATALOGUE_PDF_URL = '/shawal-apparels-catalogue.pdf';
export const CATALOGUE_PDF_FILENAME = 'shawal-apparels-catalogue.pdf';

interface CatalogueButtonsProps {
  /** Light-on-dark styling for dark sections. */
  inverted?: boolean;
  size?: 'md' | 'lg';
  className?: string;
}

/** "View Catalogue" (opens the PDF in a new tab) and "Download Catalogue" (saves the same file). */
export function CatalogueButtons({ inverted, size = 'lg', className }: CatalogueButtonsProps) {
  if (!__CATALOGUE_PDF_AVAILABLE__) return null;
  return (
    <div className={cn('flex flex-col gap-3 sm:flex-row', className)}>
      <a
        href={CATALOGUE_PDF_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonClasses(inverted ? 'light' : 'primary', size)}
        aria-label="View Catalogue (PDF, opens in a new tab)"
      >
        <FileText className="h-4 w-4" aria-hidden />
        View Catalogue
      </a>
      <a href={CATALOGUE_PDF_URL} download={CATALOGUE_PDF_FILENAME} className={buttonClasses(inverted ? 'outlineLight' : 'outline', size)} aria-label="Download Catalogue (PDF)">
        <Download className="h-4 w-4" aria-hidden />
        Download Catalogue
      </a>
    </div>
  );
}
